import { render } from "./SuscPago.vue?vue&type=template&id=2973139b&scoped=true"
import script from "./SuscPago.vue?vue&type=script&lang=js"
export * from "./SuscPago.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=2973139b&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2973139b"]])

export default __exports__